/**
 * PROinfra Shared API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Heading for a description value, currently still a placeholder. A one_to_many mapping is necessary to AnalyticDescription.
 */
export interface AnalyticDescriptionType { 
    /**
     * Internal AnalyticDescriptionType ID
     */
    id?: number;
    /**
     * Title with analysis ID
     */
    title?: string;
    /**
     * Flag indicating if the analysis is visible
     */
    isVisible?: number;
    /**
     * Position of the column in the order of table column sorting
     */
    sort?: number;
    /**
     * Template for formatting of values
     */
    formatstring?: string;
    /**
     * Title of column
     */
    description?: string;
    /**
     * Number of decimal places for specific number value field
     */
    decimals?: number;
    /**
     * Data type for the column to be sorted by
     */
    sortType?: string;
    /**
     * Flag for the pre-selected column to be pre-sorted either ascending or descending
     */
    sortOrder?: number;
}

